<template>
    <fieldset>
        <h4>{{ trans('Log In') }}</h4>

        <div id="form-email-login" class="form-group">
            <input v-model="email" placeholder="Email Address" id="username" type="email" name="username" aria-describedby="append-username" class="form-control email-login">
        </div>
        <div id="form-password-login" class="form-group">
            <input placeholder="Password" @keyup.enter="login" id="password" type="password" name="password" v-model="password" aria-describedby="append-password" class="form-control password-login" />
        </div>
        <div class="alert alert-danger" v-if="errors && errors.length">
                <li v-for="error in errors">
                    {{ error.message }}
                </li>
        </div>
        <label class="form-remember-login  css-input switch switch-sm switch-primary">
            <input id="login-remember-me" type="checkbox" name="remember-me" v-model="remember" />
            <span></span> Remember Me?
        </label>
        <div class="form-group pull-right login-button">
            <button @click.prevent="login" type="submit" class="btn btn-primary btn-lg btn-block" :class="{'btn-submitting' : submitting}">
                <i class="icon icon-spinner fa-spin" v-if="submitting"></i>
                <span>{{ submitting ? 'Logging in' : 'Log In'}}</span>
            </button>
        </div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default : '' }
        },
        data: function() {
            return {
                submitting: false,
                errors: [],
                email: '',
                password: '',
                remember: false
            }
        },
        created() {
//            this.$eventHub.$on('set' + this.name + 'User', this.setUser);
        },
        methods: {
            login() {
                if (this.submitting) return;
                this.errors = [];
                this.submitting = true;
                var params = new URLSearchParams();
                params.append('email', this.email);
                params.append('password', this.password);
                params.append('remember', this.remember);
                this.axios.post('/api/login', params).then((response) => {
                    this.submitting = false;
                    this.handleResponse(response.data);
                }).catch((error) => {
                    this.submitting = false;
                    this.handleError(error);
                    location.reload(true);
                });
            },
            handleResponse(data) {
                if (typeof data.error !== 'undefined') {
                    if (data.error === 'password') {
                        this.customError('Sorry, the password was incorrect.');
                        return;
                    }
                    this.customError(data.error);
                }
                if (typeof data.errors !== 'undefined') {
                    $.each(data.errors, (key, value) => {
                        this.customError(value[0]);
                    });
                }
                if (typeof data.redirect !== 'undefined') {
                    window.location = data.redirect;
                }
            },
            customError(message) {
                this.errors.push({
                    error_code: 500,
                    message: message
                });
            },
            handleError(error) {
                if (typeof error.response['data'] !== 'undefined' &&
                    this.handleResponse(error.response.data)) {
                    return;
                }
                this.customError('An unspecified error occurred.');
            },
        },
    }
</script>
